import forOwn from 'mout/object/forOwn'
import keys from 'mout/object/keys'
import values from 'mout/object/values'
import checkRating from './checkRating';

export default function getNoBlanksRating(userAssessment, studentScoring) {
  const ratingThresholds = {
    'Composite': [
      {percent: 97, rating: 5},
      {percent: 90, rating: 4},
      {percent: 82, rating: 3},
      {percent: 75, rating: 2},
      {percent: 70, rating: 1},
    ]
  }

  // for each student, in each subject, compare the number of answersByItem
  // to the number of answers

  const subjects = ['English', 'Math', 'Reading', 'Science']
  let subjectToSubtestMap = {}
  forOwn(userAssessment.assessmentSubtests, function addToSubjectMap(assessmentSubtest, key) {
    subjectToSubtestMap[assessmentSubtest.setId] = assessmentSubtest.displayName
  })

  function subtestCompleteQ(studentScore, subtestId) {
    return studentScore.scoring.bySubtest[subtestId].complete
  }
  
  function checkOneSubjectNoBlanks(studentScore, subtestId) {
    const allAnswers = studentScore.answers[subtestId]
    const studentAnswersObj = !!studentScore.answersByItem && studentScore.answersByItem[subtestId]
    let studentAnswers = []
    forOwn(studentAnswersObj, function checkIfAnswerExists(answer) {
      if (answer) {
        studentAnswers.push(answer)
      }
    })
    return allAnswers.length === studentAnswers.length
  }

  function checkForCompositeNoBlanks(oneStudentNoBlanks) {
    const checks = values(oneStudentNoBlanks)
    if (checks.every(val => val === true)) {
      return true
    } else {
      return false
    }
  }

  function checkOneStudentNoBlanks(studentScore, subjectToSubtestMap) {
    const subtestIds = keys(studentScore.answers)
    let oneStudentNoBlanks = {}
    subtestIds.forEach(function checkForBlanks(subtestId) {
      // only include if subtest complete
      if (subtestCompleteQ(studentScore, subtestId)) {
        const subject = subjectToSubtestMap[subtestId]
        oneStudentNoBlanks[subject] = checkOneSubjectNoBlanks(studentScore, subtestId)
      }
    })
    // only score composite if all four tests complete
    if (values(oneStudentNoBlanks).length === 4) {
      oneStudentNoBlanks['Composite'] = checkForCompositeNoBlanks(oneStudentNoBlanks)
    }
    return oneStudentNoBlanks
  }

  function checkAllStudentsNoBlanks(studentScoring, subjectToSubtestMap) {
    let noBlanksData = []
    values(studentScoring).forEach((studentScore) => {
      noBlanksData.push(checkOneStudentNoBlanks(studentScore, subjectToSubtestMap))
    })
    return noBlanksData
  }

  function calculatePercentages(studentScoring, subjectToSubtestMap) {
    const noBlanksData = checkAllStudentsNoBlanks(studentScoring, subjectToSubtestMap)
    let percentages = {
      'English': {raw: 0, possible: 0, percent: 0},
      'Math': {raw: 0, possible: 0, percent: 0},
      'Reading': {raw: 0, possible: 0, percent: 0},
      'Science': {raw: 0, possible: 0, percent: 0},
      'Composite': {raw: 0, possible: 0, percent: 0},
      calcPercent: function(subject) {
        if (this[subject].possible !== 0) {
          this[subject].percent = Math.round(this[subject].raw / this[subject].possible * 100)
        } else {
          this[subject].percent = 0
        }
      },
      calcAllPercents: function() {
        const subjs = ['English','Math','Reading','Science','Composite']
        subjs.forEach(subj => this.calcPercent(subj))
      },
    }
    noBlanksData.forEach(function tallyNoBlanks(noBlanks) {
      forOwn(noBlanks, function tallyNoBlank(val, key) {
        percentages[key].possible += 1
        percentages[key].raw += val ? 1 : 0
      })
    })
    percentages.calcAllPercents()
    return percentages
  }

  function calculateRating(studentScoring, subjectToSubtestMap) {
    const percentages = calculatePercentages(studentScoring, subjectToSubtestMap)
    function ratingTest(r, score) {
      return score > r.percent
    }
    let noBlanksRatings = {}
    const score = percentages['Composite'].percent
    noBlanksRatings.stars = checkRating(ratingThresholds, 'Composite', score, ratingTest)
    noBlanksRatings.percents = {}
    const subjs = ['English','Math','Reading','Science','Composite']
    subjs.forEach(function insertPercents(subj) {
      noBlanksRatings.percents[subj] = percentages[subj].percent / 100
    })
    return noBlanksRatings
  }

  return calculateRating(studentScoring, subjectToSubtestMap)
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getNoBlanksRating.js